export default __webpack_public_path__ + "static/media/hamburger.d128338e.svg";